import React from 'react';
import { Container } from '../../../components';
import styles from './style.module.css';
const index = () => {
  return (
    <div className={styles.bookBanner} style={{ backgroundImage: "url('../assets/images/bookbanner.jpg')" }}>
      <Container full>
        <div className={styles.banner}>
          <div className={styles.inner}>
            {/* <img src={'./assets/images/bookbanner.png'} alt="book-banner" width="100% !important" height="auto !important" /> */}
            <div className={styles.content}>
              <h2>Planning for a full package Umrah?</h2>
              <h4>Design your perfect trip to Makkah and Madinah.</h4>
              <h4>Book Online</h4>
              <button>Book Now</button>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default index;
